export const logout = () => {
    ['vesselInfo', 'loginInfo'].forEach(element => {
        localStorage.removeItem(element);
    });
    window.location.reload()
    /* let path = JSON.parse(localStorage.getItem('loginPath'))
    path.pathName === '/' || path.pathName === '/login' ? window.location.reload('/login') : window.location.reload('/saas-login') */
};